export const brandGradients = [
  ['#FFF6D1', '#FFFFFF'],
  ['#FDE3D6', '#FFFFFF'],
  ['#DFFFEF', '#FFFFFF'],
] as const

export const CUSTOMER_DETAILS_OCCUPATION_ICONS = {
  salaried:
    'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/office_bag_024c4b55f2.webp',
  selfEmployed:
    'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/employed_self_e0265fe1ce.webp',
} as const

export const LOAN_OFFER_BENEFIT_ICONS = [
  'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/moneybag_outlined_f17bab87c7.webp',
  'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/interest_rate_231546bd4b.webp',
  'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/timeline_c16707d3d2.webp',
] as const

export const userFlowLoadingLottieUrl =
  'https://zet-cms-production-b2c.s3.ap-south-1.amazonaws.com/loading_Lottie_7309c65e0e.json'

export const getBrandGradient = (index: number) =>
  brandGradients[index % brandGradients.length]

export const getBenefitTexts = (
  product?: import('./types').UserFlowProduct,
) => {
  const texts =
    product?.benefits
      ?.flatMap((benefit) => benefit?.subText || [])
      ?.filter(Boolean)
      ?.slice(0, 3) || []

  if (texts?.length) {
    return texts
  }

  return []
}

export const getBenefitIcon = (index: number) =>
  LOAN_OFFER_BENEFIT_ICONS[index] || LOAN_OFFER_BENEFIT_ICONS[2]
